/**
 * 分时资金博弈
 */
import BaseContext from '../basecontext';
import FootDectorator from '../dectorator/footdectorator';
import {LINE_TYPE} from '../setting.js';
import Util, {mergeModelData, curryFun} from '../../util/index.js';
const model = {
  superArr: {
    Type: Array,
    Default: () => ([])
  },
  largeArr: {
    Type: Array,
    Default: () => ([])
  },
  medArr: {
    Type: Array,
    Default: () => ([])
  },
  litArr: {
    Type: Array,
    Default: () => ([])
  }
};
export default class TrendCapitalState extends FootDectorator(BaseContext) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    const {superArr, largeArr, medArr, litArr} = this.state.data;
    let {maxValue, minValue} = this.calcRange({
      data: [superArr, largeArr, medArr, litArr],
      targetKey: 'value',
      isAdditional: true
    });
    maxValue = Math.max(maxValue, Math.abs(minValue));
    maxValue *= 1.1;
    minValue = -maxValue;
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    const {superArr, largeArr, medArr, litArr} = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: superArr});
    curryCalcAxis({data: largeArr});
    curryCalcAxis({data: medArr});
    curryCalcAxis({data: litArr});
  }
  _drawMain() {
    const {
      left,
      width,
      height,
      top,
      bottom,
    } = this.availArea;
    const middleY = top + height / 2;
    const {superArr, largeArr, medArr, litArr} = this.state.data;
    const {LINE} = LINE_TYPE;
    const {superLine, largeLine, mediumLine, littleLine} = this.option.FundFlowCapital;
    this._drawLine(LINE, superArr, left, bottom, superLine.lineWidth, superLine.color);
    this._drawLine(LINE, largeArr, left, bottom, largeLine.lineWidth, largeLine.color);
    this._drawLine(LINE, medArr, left, bottom, mediumLine.lineWidth, mediumLine.color);
    this._drawLine(LINE, litArr, left, bottom, littleLine.lineWidth, littleLine.color);
  }
  _drawAxisY() {
    const ctx = this.context;
    const {superLine, largeLine, mediumLine, littleLine, axisY, topText} = this.option.FundFlowCapital;
    ctx.beginPath();
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    const baseSize = this.state.baseSize;
    const space = 10; // 文字之间的间距
    const {
      left,
      top,
      right,
      bottom
    } = this.availArea;
    [topText, superLine, largeLine, mediumLine, littleLine].reduce((prev, item) => {
      ctx.fillStyle = item.color;
      ctx.font = item.sizeRatio * baseSize * this.dpr + "px " + item.fontFamily;
      const width = ctx.measureText(item.text).width;
      ctx.fillText(item.text, prev, top);
      return prev + space + width;
    }, left);
    const maxValue = this.maxValue;
    const minValue = this.minValue;
    if (!Util.isValidNumber(maxValue)) {
      return;
    }
    ctx.fillStyle = axisY.color;
    ctx.font = axisY.sizeRatio * baseSize * this.dpr + "px " + axisY.fontFamily;
    ctx.textAlign = 'right';
    ctx.fillText(maxValue.toFixed(2), right, top);
    ctx.textBaseline = 'bottom';
    ctx.fillText(minValue.toFixed(2), right, bottom);
  }
}